import type { AgentCursor as AgentCursorData } from "@/stores/canvas-store";
import { useCanvasStore } from "@/stores/canvas-store";
import { useAgentStore } from "@/stores/agent-store";
import { useCompactAgentDisplayStore } from "@/stores/compact-agent-display-store";
import { agentNameKey } from "@/components/cursors/agent-avatar-dock-utils";
import { getWindowDisplayId } from "./use-window-role";
import { useDictation } from "./use-dictation";

function navigateToCompactAgentResult(cursor: AgentCursorData) {
  if (!cursor.frozen || !cursor.targetFrameId) return;
  if (!useCanvasStore.getState().navigateToFrame(cursor.targetFrameId)) {
    window.setTimeout(() => {
      useCanvasStore.getState().navigateToFrame(cursor.targetFrameId!);
    }, 200);
  }
}

function selectAgentForCursor(cursor: AgentCursorData) {
  const key = agentNameKey(cursor.name);
  if (!key) return;
  const agent = useAgentStore
    .getState()
    .agents.find((item) => agentNameKey(item.template_name) === key);
  if (agent) useAgentStore.getState().selectAgent(agent.id);
}

function summonCompactAgentFollowUp(
  cursor: AgentCursorData,
  mode: "voice" | "text",
) {
  const agentKey = agentNameKey(cursor.name);
  selectAgentForCursor(cursor);
  if (mode === "voice") {
    void useDictation.getState().toggle();
    return;
  }
  const anchor = useCompactAgentDisplayStore.getState().firstAvatarAnchor;
  useCanvasStore.getState().setPendingCursorSummon({
    x: anchor?.x ?? window.innerWidth / 2,
    y: anchor?.y ?? Math.max(40, window.innerHeight - 80),
    agentKey: agentKey || undefined,
    displayId: anchor?.displayId ?? getWindowDisplayId(),
    placement: "bottom",
  });
}

export { navigateToCompactAgentResult, summonCompactAgentFollowUp };
